import React, { useEffect, useState } from 'react';

const FlagIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 22v-7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const PlayIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="6,3 20,12 6,21" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StartABusinessDiagram: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      id: 1,
      label: 'Name Selection',
      position: { x: 59, y: 8 },
      hasFlagIcon: true,
      color: '#98F700'
    },
    {
      id: 2,
      label: 'State Selection',
      position: { x: 2.5, y: 80 },
      color: '#3890C2'
    },
    {
      id: 3,
      label: 'Business Structure',
      position: { x: 2.5, y: 140 },
      color: '#6EA9CA'
    },
    {
      id: 4,
      label: 'File With State',
      position: { x: 112, y: 190 },
      color: '#6FD2D8'
    },
    {
      id: 5,
      label: 'Tax ID (EIN)',
      position: { x: 112, y: 250 },
      color: '#7FBCC0'
    },
    {
      id: 6,
      label: 'Licenses & Permits',
      position: { x: 2.5, y: 300 },
      color: '#3CC396'
    },
    {
      id: 7,
      label: 'Bank Account',
      position: { x: 2.5, y: 360 },
      color: '#73D8B6'
    },
    {
      id: 8,
      label: 'Compliance',
      position: { x: 59, y: 436 },
      hasPlayIcon: true,
      color: '#2D62B8'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prevStep) => (prevStep + 1) % steps.length);
    }, 1000);

    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <div className="w-full max-w-md ">
      {/* Title */}
      <h3 className="text-xl font-bold bg-gradient-to-r from-[#131834] to-[#4569FD] bg-clip-text text-transparent mb-6 text-center">
        Business Formation Roadmap
      </h3>

      {/* SVG Container for the entire roadmap */}
      <div className="relative flex justify-center">
        <svg
          width="400"
          height="480"
          viewBox="0 0 400 480"
          className="w-full h-auto max-w-sm"
        >
          {/* Your original track path scaled and centered */}
          <g transform="translate(143, 20) scale(1)">
            <path
              d="M113.859 188.605H110.61V195.096H113.859V188.605ZM112.235 208.056C112.061 208.056 111.888 208.06 111.715 208.068H112.751C112.581 208.06 112.408 208.056 112.235 208.056ZM113.859 203.848V201.582H110.61V203.848C111.146 203.799 111.686 203.767 112.235 203.767C112.783 203.767 113.327 203.799 113.859 203.848ZM113.859 214.559H110.61V221.045H113.859V214.559ZM113.859 230.946V227.532H110.61V230.946C111.686 231.099 112.783 231.099 113.859 230.946ZM113.859 240.508H110.61V246.995H113.859V240.508ZM113.859 256.747V253.481H110.61V256.747C110.61 257.722 110.521 258.698 110.348 259.657L113.541 260.246C113.755 259.089 113.859 257.92 113.859 256.747ZM113.859 182.099C113.827 179.728 113.355 177.386 112.469 175.189L109.457 176.402C110.195 178.229 110.586 180.176 110.61 182.143L113.859 182.099ZM111.005 266.821L108.24 265.116C107.204 266.793 105.865 268.26 104.293 269.453L106.264 272.033C108.151 270.602 109.76 268.837 111.005 266.821ZM108.671 169.255C107.05 167.525 105.128 166.11 102.991 165.078L101.576 168.001C103.35 168.856 104.954 170.033 106.301 171.472L108.671 169.255ZM99.9553 275.198L99.0563 272.082C97.6172 272.493 96.1256 272.703 94.6259 272.703H93.0738V275.944H94.6259C96.4319 275.944 98.2219 275.694 99.9553 275.198ZM96.178 163.236C95.666 163.196 95.146 163.172 94.6259 163.172H89.5505V166.417H94.6259C95.0573 166.417 95.4926 166.433 95.9159 166.469L96.178 163.236ZM86.5753 272.703H80.0768V275.944H86.5753V272.703ZM83.052 163.172H76.5575V166.417H83.052V163.172ZM73.5783 272.703H67.0798V275.944H73.5783V272.703ZM70.059 163.172H63.5605V166.417H70.059V163.172ZM61.1296 0.503418H57.8804V6.99386H61.1296V0.503418ZM61.1296 16.2135C60.5934 16.2699 60.0532 16.2941 59.5171 16.2941C58.9688 16.2941 58.4246 16.2659 57.8804 16.2095V19.9667H61.1296V16.2135ZM61.1296 26.4531H57.8804V32.9435H61.1296V26.4531ZM61.0006 402.786H57.7514V409.272H61.0006V402.786ZM61.0006 415.762H57.7514V422.249H61.0006V415.762ZM61.0006 428.735H57.7514V435.222H61.0006V428.735ZM61.0369 39.5871L57.7997 39.2687C57.6103 41.2239 57.058 43.1307 56.167 44.8843L59.0656 46.3517C60.1379 44.2393 60.8071 41.9455 61.0369 39.5871ZM60.1943 395.904C59.513 393.638 58.4165 391.514 56.9572 389.643L54.3933 391.635C55.6027 393.187 56.5178 394.953 57.0821 396.835L60.1943 395.904ZM60.5813 272.703H54.0828V275.944H60.5813V272.703ZM57.062 163.172H50.5635V166.417H57.062V163.172ZM54.7803 51.9472L52.6033 49.5365C51.14 50.8587 49.4468 51.8948 47.6045 52.6003L48.7655 55.6278C50.9787 54.7852 53.0186 53.5355 54.7803 51.9472ZM51.6802 384.971C49.6484 383.746 47.4029 382.911 45.0648 382.508L44.5125 385.705C46.4515 386.039 48.314 386.733 50.0031 387.749L51.6802 384.971ZM47.5843 272.703H41.0858V275.944H47.5843V272.703ZM44.065 163.172H37.5665V166.417H44.065V163.172ZM41.8276 53.6484H35.3291V56.8896H41.8276V53.6484ZM38.3042 382.226H31.8057V385.471H38.3042V382.226ZM34.5873 272.703H28.0888V275.944H34.5873V272.703ZM31.068 163.172H24.5695V166.417H31.068V163.172ZM28.8306 53.6484H22.3321V56.8896H28.8306V53.6484ZM25.3072 382.226H20.131C19.7319 382.226 19.3288 382.214 18.9297 382.185L18.6918 385.419C19.1675 385.455 19.6513 385.471 20.131 385.471H25.3072V382.226ZM20.131 275.944H21.5903V272.703H20.131C18.2967 272.699 16.4665 272.961 14.7048 273.477L15.6199 276.589C17.0873 276.162 18.6072 275.944 20.131 275.944ZM18.2605 163.067C16.3053 162.837 14.4065 162.248 12.665 161.329L11.1452 164.195C13.2415 165.304 15.5272 166.014 17.8856 166.288L18.2605 163.067ZM16.269 57.3572L15.4869 54.2128C13.181 54.7812 11.0041 55.7729 9.065 57.1395L10.9355 59.7922C12.5481 58.6553 14.3541 57.8289 16.269 57.3572ZM13.2656 380.686C11.4878 379.839 9.87933 378.670 8.5248 377.239L6.16245 379.468C7.79514 381.194 9.72614 382.597 11.8708 383.617L13.2656 380.686ZM10.3953 279.246L8.41193 276.674C6.53333 278.117 4.93692 279.895 3.70334 281.918L6.47689 283.603C7.50488 281.922 8.83118 280.447 10.3953 279.246ZM8.0733 157.689C6.77521 156.205 5.76738 154.492 5.09415 152.642L2.04243 153.742C2.84869 155.972 4.06213 158.032 5.62225 159.813L8.0733 157.689ZM6.83971 63.9807L4.13872 62.1787C2.81644 64.146 1.87312 66.3431 1.3571 68.657L4.52976 69.3585C4.96111 67.4396 5.74319 65.6174 6.83971 63.9807ZM5.34006 372.325C4.59023 370.503 4.19113 368.56 4.15485 366.592L0.905594 366.653C0.945908 369.023 1.42966 371.361 2.33269 373.554L5.34006 372.325ZM4.15082 75.466H0.901566V81.9524H4.15082V75.466ZM4.15082 94.3285V88.4388H0.901566V94.3285C1.43773 94.2761 1.97793 94.2479 2.52619 94.2479C3.07445 94.2479 3.61465 94.2761 4.15082 94.3285ZM4.15082 101.416H0.901566V107.902H4.15082V101.416ZM4.15082 114.388H0.901566V120.879H4.15082V114.388ZM4.15082 127.365H0.901566V133.852H4.15082V127.365ZM4.15082 140.338H0.901566V146.829H4.15082V140.338ZM4.15082 291.9C4.15082 290.953 4.23144 290.009 4.40076 289.074L1.19988 288.505C1.00235 289.626 0.901566 290.763 0.901566 291.9V295.262H4.15082V291.9ZM4.15082 301.748H0.901566V308.235H4.15082V301.748ZM4.15082 317.7C3.07042 317.547 1.97793 317.547 0.901566 317.7V321.212H4.15082V317.7ZM4.15082 327.698H0.901566V334.189H4.15082V327.698ZM4.15082 344.799C3.61465 344.847 3.07445 344.88 2.52619 344.88C1.97793 344.88 1.43773 344.847 0.901566 344.799V347.161H4.15082V344.799ZM4.15082 353.648H0.901566V360.138H4.15082V353.648Z"
              fill="#1e40af"
              opacity="0.8"
            />
          </g>

          {/* Step circles and labels positioned on the track */}
          {steps.map((step, index) => {
            const isActive = activeStep === index;
            const scale = isActive ? 1.2 : 1;
            const centerX = step.position.x + 143;
            const centerY = step.position.y + 20;

            return (
              <g key={step.id}>
                {/* Circle positioned on track with scaling animation */}
                <circle
                  cx={centerX}
                  cy={centerY}
                  r="14"
                  fill={step.color}
                  className="drop-shadow-md"
                  stroke="white"
                  strokeWidth="2"
                  style={{
                    transform: `scale(${scale})`,
                    transformOrigin: `${centerX}px ${centerY}px`,
                    transition: 'transform 0.2s ease-in-out'
                  }}
                />

                {/* Icon inside circle - Flag for first, Play for last, with proper scaling */}
                {step.hasFlagIcon ? (
                  <g
                    style={{
                      transform: `translate(${centerX}px, ${centerY}px) scale(${scale})`,
                      transformOrigin: '0px 0px',
                      transition: 'transform 0.2s ease-in-out'
                    }}
                  >
                    <foreignObject
                      x="-6"
                      y="-6"
                      width="12"
                      height="12"
                    >
                      <FlagIcon />
                    </foreignObject>
                  </g>
                ) : step.hasPlayIcon ? (
                  <g
                    style={{
                      transform: `translate(${centerX}px, ${centerY}px) scale(${scale})`,
                      transformOrigin: '0px 0px',
                      transition: 'transform 0.2s ease-in-out'
                    }}
                  >
                    <foreignObject
                      x="-6"
                      y="-6"
                      width="12"
                      height="12"
                    >
                      <PlayIcon />
                    </foreignObject>
                  </g>
                ) : null}

                {/* Label positioned to the side with larger text */}
                <text
                  x={(() => {
                    // Flip alignment for steps 3, 5, 6 only
                    if ([3, 5, 6].includes(step.id)) {
                      return step.position.x < 30 ? step.position.x + 161 : step.position.x + 125;
                    }
                    // Keep original alignment for all other steps
                    return step.position.x < 30 ? step.position.x + 125 : step.position.x + 161;
                  })()}
                  y={step.position.y + 26}
                  textAnchor={(() => {
                    // Flip alignment for steps 3, 5, 6 only
                    if ([3, 5, 6].includes(step.id)) {
                      return step.position.x < 30 ? "start" : "end";
                    }
                    // Keep original alignment for all other steps
                    return step.position.x < 30 ? "end" : "start";
                  })()}
                  className="text-sm font-semibold fill-gray-800"
                  style={{
                    fontSize: '16px',
                    transform: isActive ? 'scale(1.02)' : 'scale(1)',
                    transformOrigin: `${step.position.x < 30 ? step.position.x + 125 : step.position.x + 161}px ${step.position.y + 26}px`,
                    transition: 'transform 0.2s ease-in-out'
                  }}
                >
                  {step.label}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
};

export default StartABusinessDiagram;